var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"title"},[_c('span',{style:({ color: _vm.props.color || _vm.parent.constants.colors.primary + ' !important' })},[_vm._v(_vm._s(_vm.props.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }